<template>
  <div>
    <navigation-header />

    <main>
      <slot></slot>

      <!-- The enquiry band sits on every public page, so it lives in the layout
           rather than in each page. It used to be the last line of ten pages,
           copied by hand, which is why the legal, blog listing, blog post,
           portfolio listing, promotions listing, website report and automation
           preview pages had drifted without it. One owner means a page cannot
           forget it and a new page cannot omit it.

           Admin screens render through `Layouts/Admin.vue`, so the band is
           absent from them by construction rather than by remembering to leave
           it out. The error page has no layout at all and keeps its own two
           actions. -->
      <call-to-action />
    </main>

    <chat />

    <language />

    <scroll-to-top />

    <cursor />

    <navigation-footer />
  </div>
</template>

<script>
import Chat from '@/Components/Chat.vue';
import Cursor from '@/Components/Cursor.vue';
import Language from '@/Components/Language.vue';
import NavigationFooter from '@/Components/Footer.vue';
import NavigationHeader from '@/Components/Header.vue';
import ScrollToTop from '@/Components/ScrollToTop.vue';
import CallToAction from '@/Pages/Index/Sections/CallToAction.vue';
import { setWidgetLanguage } from '@/turnstile';

import { faChevronDown, faLanguage } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';

FontAwesomeLibrary.add(faChevronDown, faFacebookF, faInstagram, faLanguage, faLinkedinIn, faTwitter, faWhatsapp, faYoutube);

export default {
  components: {
    CallToAction,
    Chat,
    Cursor,
    Language,
    NavigationFooter,
    NavigationHeader,
    ScrollToTop
  },

  /* The widget script belongs to the public layout. Admin screens use a
     different layout, so they never load it. `created` runs before the enquiry
     form and the chat mount their widgets and wait on `window.turnstile`. */
  created() {
    setWidgetLanguage(this.$i18n.global.locale.value);

    const sitekey = this.$page.props.turnstile && this.$page.props.turnstile.sitekey;

    if (!sitekey || document.querySelector('script[data-turnstile]')) {
      return;
    }

    const script = document.createElement('script');

    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.dataset.turnstile = '';
    document.head.appendChild(script);
  },

  watch: {
    '$i18n.global.locale.value'(code) {
      setWidgetLanguage(code);
    }
  }
};
</script>
